<div class="padding-wrapper">

    <div *ngIf="thematics" class="wrapper">
        <h1 class="margin-bottom">{{ 'thematics.sherpaTitle' | translate }}</h1>
        <app-info >
            <p>{{ 'thematics.sherpaInfo' | translate:{ count: thematics.length } }}</p>
        </app-info>

        <div class="wrap margin-bottom margin-top center-children-vertically">
            <div class="bubble pointer center-vertically-by-margin row gap center-children"
                 [dropdownTriggerFor]="pillarsDropdown" dropdownPosition="start">{{ 'thematics.pillars' | translate }}
                <app-icon type="chevron-down"/>
            </div>
            <app-dropdown [closeOnClick]="false" #pillarsDropdown>
                <div class="column gap base-padding">
                    <div class="bubble pointer" (click)="selectPillar(pillar.id)"
                         [style.border-color]="pillar.selected ? mediumPillarColors[pillar.id]: 'grey'"
                         *ngFor="let pillar of pillarCheckboxes">{{ pillar.key | translate }}</div>
                </div>
            </app-dropdown>
            <div class="bubble pointer row gap center-children margin-bottom center-vertically-by-margin"
                 [dropdownTriggerFor]="dynamicsDropdown" dropdownPosition="center">{{ 'thematics.groupDynamic' | translate }}
                <app-icon type="chevron-down"/>
            </div>
            <app-checkbox [formControl]="onlyMyThematics">{{ 'thematics.onlyMine' | translate }}</app-checkbox>
            <app-dropdown [closeOnClick]="false" #dynamicsDropdown>
                <div class="column gap base-padding ">
                    <div class="bubble pointer" (click)="selectDynamic(dynamic.id)"
                         [style.border-color]="dynamic.selected ? dynamic.id === DynamicType.COACHING ? '#8C5FB0': '#FFA135': ''"
                         *ngFor="let dynamic of dynamicTypeCheckboxes">{{ dynamic.key | translate }}</div>
                </div>
            </app-dropdown>
            <div class="bubble pointer row gap center-children margin-bottom center-vertically-by-margin"
                 (click)="selectPillar(pillar.id)"
                 [style.border-color]="pillar.selected ? mediumPillarColors[pillar.id]: 'grey'"
                 *ngFor="let pillar of pillarCheckboxesSelected$.getValue()">{{ pillar.key | translate }}
                <app-icon type="close"/>
            </div>
            <div class="bubble pointer row gap center-children margin-bottom center-vertically-by-margin"
                 (click)="selectDynamic(dynamic.id)"
                 [style.border-color]="dynamic.selected ? dynamic.id === DynamicType.COACHING ? '#8C5FB0': '#FFA135': ''"
                 *ngFor="let dynamic of dynamicTypeCheckboxesSelected$.getValue()">{{ dynamic.key | translate }}
                <app-icon type="close"/>
            </div>
        </div>

        <div class="column gap margin-top">
            <div class="header row" *ngFor="let checkbox of shownThematics">
                <div class="image-slot">
                    <app-image [alt]="checkbox.thematic.slug" [width]="248" [height]="192" [src]="checkbox.thematic.imageUrl"/>
                </div>
                <div class="column gap grow">
                    <div class="space-between row">
                        <p class="thematic-name" [ngStyle]="{'background-color': getPillarColor(checkbox.thematic)}">
                            <strong>{{ checkbox.thematic.name | thematicField: checkbox.thematic.slug:'name' }}</strong></p>
                    </div>
                    <div class="header-description column no-gap">
                        <h3 class="cooper margin-bottom">{{ checkbox.thematic.title | thematicField: checkbox.thematic.slug:'title' }}</h3>
                        <div class="text-ellipsis row gap mobile-hidden">
                            <div class="grow">
                                <p class="thematic-resume text-ellipsis overflow-hidden">{{ checkbox.thematic.resume | thematicField: checkbox.thematic.slug:'resume' }}</p>
                            </div>
                            <div class="shrink discover-button row gap">
                                <app-button [outline]="true" (click)="goToThematic(checkbox.thematic)">{{ 'thematics.discover' | translate }}
                                </app-button>
                                <app-icon size="40" [class]="checkbox.checked ? 'success' : 'white'" type="check" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
